import {
  Alert, Button, IconCdn, Skeleton, CircleProgressBar,
  IconSupport,
  Tooltip,
  ChipCheckbox,
  IconAtencion,
  Pagination,
  SelectField,
  IconChevron,
} from 'gatorcomponents';
import React, { useState, useEffect, useCallback } from 'react';
import * as Styles from './FeatureSpeed.styles';
import PropTypes from 'prop-types';
import { formatDate } from '@/utils/Formatters/formatDate';
import { useResize } from '@/hooks/useResize';
import { YoutubeEmbed } from './components/index';
import { cloudflareAnalytics } from '@/analytics/cloudflare';

const FeatureSpeed = ({
  title = 'title',
  firstRow = 'first row',
  secondRow = 'second row',
  stillHave = 'still have',
  dontHave = 'dont have',
  initTestLabel = 'init',
  listTitle = '',
  loadingLastAnalysis = true,
  loadingHistory = true,
  leftAmount,
  requestSpeedAnalysis,
  getSpeedHistory,
  history,
  lastAnalysis,
  resultTitle,
  resultAnalysisTitle,
  resultItems,
  reduTestLabel,
  testDate,
  insideList = false,
  showList,
  hideList,
  failedTitle,
  videoAbout,
  failedDescription,
  historyListTitle,
  itemsPerPageLabel,
  dateLabel,
  domainLabel,
  scoreLabel,
  showDetailsButtonLabel,
  getHistoryError = {
    title: 'Falha ao carregar os dados',
    description: 'Não foi possível carregar os dados solicitados. Por favor, aguarde e tente novamente em alguns minutos.',
  },
  getHistoryRequestStatus,
  resetRequestStatus,
}) => {
  const [analysisView, setAnalysisView] = useState('desktopReport');
  const [listItemAnalysisView, setListItemAnalysisView] = useState('desktopReport');
  const [listExpanded, setListExpanded] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [pageIndex, setPageIndex] = useState(0);
  const [historyItemOpen, setHistoryItemOpen] = useState(null);

  const itemsPerPageOptions = [
    {
      value: 5,
      label: '5',
    },
    {
      value: 10,
      label: '10',
    },
    {
      value: 50,
      label: '50',
    },
  ];

  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 960;

  const paginationStartsIn = 1;
  const currentPage = pageIndex + paginationStartsIn;
  const historyList = history && history.results;
  const paginationInfos = history && history.result_info;

  const pagesAmount = paginationInfos && Math.ceil(paginationInfos.total_count / itemsPerPage);

  const isFailedAnalysis = lastAnalysis && (lastAnalysis.desktopReport.state.toLowerCase() === 'failed' || lastAnalysis.mobileReport.state.toLowerCase() === 'failed');
  const isComplitedAnalysis = lastAnalysis && lastAnalysis.desktopReport.state.toLowerCase() === 'complete' && lastAnalysis.mobileReport.state.toLowerCase() === 'complete';
  const getHistoryListFailed = getHistoryRequestStatus === 'failure';

  const handleClick = () => {
    requestSpeedAnalysis && requestSpeedAnalysis();
  };

  const handleSetPage = (page) => {
    const newPage = page + paginationStartsIn;

    if (newPage !== currentPage) {
      getSpeedHistory({ currentPage: newPage, perPage: itemsPerPage, updateLastAnalysis: false });
      setPageIndex(page);
    }
  };

  const handleSetItemsPerPage = (updatedPerPage) => {
    if (updatedPerPage === itemsPerPage || loadingHistory) {
      return;
    }

    setItemsPerPage(updatedPerPage);
    setPageIndex(0);
    getSpeedHistory({ currentPage: 1, perPage: updatedPerPage, updateLastAnalysis: false });
  };

  const getAnalysisStatus = (number) => {
    if (number >= 90) {
      return 'good';
    }

    if (number >= 50) {
      return 'neutral';
    }

    return 'bad';
  };

  const getStatusVariant = (number) => {
    if (number >= 90) {
      return 'success';
    }

    if (number >= 50) {
      return 'attention';
    }

    return 'problem';
  };

  const shouldRenderResult = isComplitedAnalysis;

  const handleCurrentTestChip = (e) => {
    setAnalysisView(e.value);
  };

  const handleListItemChip = (e) => {
    setListItemAnalysisView(e.value);
  };
  const handleResetRequestStatus = useCallback(() => {
    resetRequestStatus();
  }, [resetRequestStatus]);

  useEffect(() => {
    handleResetRequestStatus();
  }, [handleResetRequestStatus]);

  if (loadingLastAnalysis || loadingHistory) {
    return (
      <Styles.Wrapper>
        <Skeleton
          height="200px"
          width="100%"
        />

        <Skeleton
          height="200px"
          width="100%"
        />
      </Styles.Wrapper>
    );
  }

  const showHistoryItemDetails = (id) => {
    if (id === historyItemOpen) {
      setHistoryItemOpen(null);
      return;
    }

    setHistoryItemOpen(id);
  };

  const showDetailsButtonIcon = ({ open = false }) => (
    <IconChevron
      direction={open ? 'top' : 'bottom'}
      color="primaryDark"
      size="md"
    />
  );

  const mountAnalysisDetails = ({
    analysis, listExpanded = true, isHistoryItem = false,
  } = {}) => {
    const currentAnalysisView = isHistoryItem ? listItemAnalysisView : analysisView;

    return (
      <Styles.AnalysisItemsContainer $listExpanded={listExpanded} $padding={isHistoryItem}>
        {isHistoryItem && (
          <Styles.ViewRow>
            <ChipCheckbox
              label="Desktop"
              active={listItemAnalysisView === 'desktopReport'}
              onMark={handleListItemChip}
              value="desktopReport"
              id={`listDesktopReport-${analysis.id}`}
            />
            <ChipCheckbox
              label="Mobile"
              active={listItemAnalysisView === 'mobileReport'}
              onMark={handleListItemChip}
              value="mobileReport"
              id={`listMobileReport-${analysis.id}`}
            />
          </Styles.ViewRow>
        )}

        <Styles.AnalysisItemsWrapper>
          {Object.keys(analysis[currentAnalysisView]).map((key) => {
            if (key === 'performanceScore' || key === 'state' || key === 'deviceType') return null;

            return (
              <Styles.AnalysisItemsCard key={`${key}_${analysis.id}`} data-testid={`${key}_${analysis.id}`}>
                <Styles.AnalysisItemsCardTitle>
                  {resultItems[key]}
                  <Tooltip allowDynamicFit content={resultItems[`${key}Tooltip`]}>
                    <IconSupport size="sm" />
                  </Tooltip>
                </Styles.AnalysisItemsCardTitle>

                <Styles.AnalysisItemsCardValue>
                  <Styles.DotColor $variant={analysis[currentAnalysisView][key].status} />
                  {analysis[currentAnalysisView][key].value}
                </Styles.AnalysisItemsCardValue>
              </Styles.AnalysisItemsCard>
            );
          })}
        </Styles.AnalysisItemsWrapper>
      </Styles.AnalysisItemsContainer>
    );
  };

  return (
    <Styles.Wrapper data-testid="featureSpeed">
      {!isComplitedAnalysis && (
        <Styles.Container>
          <Styles.DesktopIconWrapper>
            <IconCdn />
          </Styles.DesktopIconWrapper>
          <Styles.Column>
            <Styles.Title>
              <Styles.MobileIconWrapper>
                <IconCdn />
              </Styles.MobileIconWrapper>
              {title}
            </Styles.Title>
            <Styles.FirstRow>
              {firstRow}
            </Styles.FirstRow>

            <Styles.SecondRow>
              {secondRow}
            </Styles.SecondRow>

            {leftAmount !== undefined && (
              <Styles.AlertWrapper>
                <Alert
                  testId="alertAmount"
                  variant={leftAmount > 0 ? 'info' : 'warning'}
                  withoutBackground
                  description={leftAmount > 0 ? stillHave : dontHave}
                />
              </Styles.AlertWrapper>
            )}

            <Styles.ActionWrapper>
              <Button
                testId="init-test-button"
                label={initTestLabel}
                size="large"
                width="full"
                onClick={handleClick}
                disabled={leftAmount === 0}
              />
            </Styles.ActionWrapper>
          </Styles.Column>
        </Styles.Container>
      )}

      {shouldRenderResult && (
        <Styles.Container>
          <Styles.Column>
            <Styles.TitleRow>
              <Styles.Title>
                {resultTitle}
              </Styles.Title>

              <Styles.TestDate $hideOnMobile>
                {testDate(new Date(lastAnalysis.date))}
              </Styles.TestDate>
            </Styles.TitleRow>

            <Styles.AlertWrapper id="AlertWrapper" padding>
              <Alert
                testId="alertAmountResult"
                variant={leftAmount > 0 ? 'info' : 'warning'}
                withoutBackground
                description={leftAmount > 0 ? stillHave : dontHave}
              />

              <Button
                testId="init-test-button"
                label={reduTestLabel}
                size="large"
                width="full"
                onClick={handleClick}
                disabled={leftAmount === 0}
              />

              <Styles.TestDate $hideOnDesktop>
                {testDate(new Date(lastAnalysis.date))}
              </Styles.TestDate>
            </Styles.AlertWrapper>

            <Styles.ViewRow>
              <ChipCheckbox
                label="Desktop"
                active={analysisView === 'desktopReport'}
                onMark={handleCurrentTestChip}
                value="desktopReport"
                id="desktopReport"
              />
              <ChipCheckbox
                label="Mobile"
                active={analysisView === 'mobileReport'}
                onMark={handleCurrentTestChip}
                value="mobileReport"
                id="mobileReport"
              />
            </Styles.ViewRow>

            {!insideList && (
              <Styles.CircleProgressBarWrapper>
                <Styles.CircleProgressBarContent>
                  <CircleProgressBar
                    progress={lastAnalysis[analysisView].performanceScore}
                    variant={getStatusVariant(lastAnalysis[analysisView].performanceScore)}
                  />

                  <Styles.CircleProgressBarDescriptionWrapper>
                    <Styles.CircleProgressBarDescriptionTitle>
                      {resultAnalysisTitle[getAnalysisStatus(lastAnalysis[analysisView].performanceScore)]}
                    </Styles.CircleProgressBarDescriptionTitle>

                    <Styles.CircleProgressBarColorsList>
                      <Styles.CircleProgressBarColorsListItem $variant="good">100-90</Styles.CircleProgressBarColorsListItem>
                      <Styles.CircleProgressBarColorsListItem $variant="neutral">89-50</Styles.CircleProgressBarColorsListItem>
                      <Styles.CircleProgressBarColorsListItem $variant="bad">49-0</Styles.CircleProgressBarColorsListItem>
                    </Styles.CircleProgressBarColorsList>
                  </Styles.CircleProgressBarDescriptionWrapper>
                </Styles.CircleProgressBarContent>
                <Styles.CircleProgressBarVideoWrapper data-testid="circleProgressBarVideoWrapper">
                  <Styles.CircleProgressBarVideoTitle>{videoAbout.title}</Styles.CircleProgressBarVideoTitle>
                  <YoutubeEmbed
                    src={videoAbout.src}
                    title={videoAbout.title}
                    alt={videoAbout.title}
                    width="100%"
                    height="260px"
                    analyticsEventClick={() => cloudflareAnalytics.clickFeatureSpeedVideo()}
                  />
                </Styles.CircleProgressBarVideoWrapper>
              </Styles.CircleProgressBarWrapper>
            )}


            {!insideList && (
              <Styles.ListTitle>
                <Styles.Title>
                  {listTitle}
                </Styles.Title>
              </Styles.ListTitle>
            )}

            {mountAnalysisDetails({ analysis: lastAnalysis, listExpanded })}

            <Styles.AnalysisMobileToggle $listExpanded={listExpanded}>
              <Button
                label={listExpanded ? hideList : showList}
                onClick={() => setListExpanded(!listExpanded)}
                variant="secondary"
              />
            </Styles.AnalysisMobileToggle>

          </Styles.Column>
        </Styles.Container>
      )}

      {isFailedAnalysis && (
        <Styles.Container $error={isFailedAnalysis}>
          <IconAtencion size="xl" secondaryColor="problemLight" />

          <Styles.Title>
            {failedTitle}
          </Styles.Title>

          <Styles.FirstRow>
            {failedDescription}
          </Styles.FirstRow>
        </Styles.Container>
      )}

      {getHistoryListFailed && (
        <Styles.Container $error>
          <IconAtencion size="xl" secondaryColor="problemLight" />

          <Styles.Title>
            {getHistoryError.title}
          </Styles.Title>

          <Styles.FirstRow>
            {getHistoryError.description}
          </Styles.FirstRow>
        </Styles.Container>
      )}

      {historyList && (
        <Styles.Container $widthFull>
          <Styles.HistoryWrapper>
            <Styles.Title>
              {historyListTitle}
            </Styles.Title>

            {loadingHistory && (
            <Styles.SkeletonList>
              {Array.from({ length: 5 }).map(() => (
                <Skeleton height="80px" width="100%" />
              ))}
            </Styles.SkeletonList>
            )}

            {!mobile && !loadingHistory && (
            <Styles.Table>
              <Styles.TableHeader>
                <Styles.TableRow $head>
                  <Styles.TableHead>{dateLabel}</Styles.TableHead>
                  <Styles.TableHead>{domainLabel}</Styles.TableHead>
                  <Styles.TableHead>{scoreLabel}</Styles.TableHead>
                </Styles.TableRow>
              </Styles.TableHeader>

              {historyList.map((item) => {
                const isLastAnalysis = lastAnalysis && lastAnalysis.id === item.id;

                if (isLastAnalysis) {
                  return;
                }

                return (
                  <Styles.TableBody key={`table-row-${item.id}`}>
                    <Styles.TableRow>
                      <Styles.TableCell>{formatDate(item.date)}</Styles.TableCell>
                      <Styles.TableCell>{item.url}</Styles.TableCell>
                      <Styles.TableCell>
                        <Styles.PerformanceCell>
                          <Styles.DotColor $variant={getAnalysisStatus(item[analysisView].performanceScore)} />
                          {`${item[analysisView].performanceScore}%`}
                        </Styles.PerformanceCell>
                      </Styles.TableCell>
                      <Styles.TableCell>
                        <Button
                          testId={`expand-item-${item.id}`}
                          variant="text"
                          size="medium2"
                          label={showDetailsButtonLabel}
                          iconRight={showDetailsButtonIcon({ open: item.id === historyItemOpen })}
                          onClick={() => showHistoryItemDetails(item.id)}
                        />
                      </Styles.TableCell>
                    </Styles.TableRow>
                    <Styles.TableRow>
                      <Styles.HistoryItemDetails $open={item.id === historyItemOpen} colSpan={4}>
                        {mountAnalysisDetails({
                          analysis: item,
                          listExpanded: item.id === historyItemOpen,
                          isHistoryItem: true,
                        })}
                      </Styles.HistoryItemDetails>
                    </Styles.TableRow>
                  </Styles.TableBody>
                );
              })}
            </Styles.Table>
            )}

            {mobile && !loadingHistory && (
              <Styles.MobileHistoryContainer>
                {historyList && historyList.map((item, index) => {
                  const isLastAnalysis = lastAnalysis && lastAnalysis.id === item.id;

                  if (isLastAnalysis) {
                    return;
                  }

                  return (
                    <Styles.MobileHistoryItem $firstItem={index === 0}>
                      <Styles.MobileItemText>
                        <strong>{`${dateLabel}: `}</strong>
                        {formatDate(item.date)}
                      </Styles.MobileItemText>
                      <Styles.MobileItemText>
                        <strong>{`${domainLabel}: `}</strong>
                        {item.url}
                      </Styles.MobileItemText>
                      <Styles.MobileItemText>
                        <strong>{`${scoreLabel}: `}</strong>
                        <Styles.PerformanceCell>
                          <Styles.DotColor $variant={getAnalysisStatus(item[analysisView].performanceScore)} />
                          {`${item[analysisView].performanceScore}%`}
                        </Styles.PerformanceCell>
                      </Styles.MobileItemText>
                      <Styles.DetailsButtonContainer>
                        <Button
                          variant="text"
                          label={showDetailsButtonLabel}
                          iconRight={showDetailsButtonIcon({ open: item.id === historyItemOpen })}
                          onClick={() => showHistoryItemDetails(item.id)}
                        />
                      </Styles.DetailsButtonContainer>
                      <Styles.MobileHistoryItemDetails>
                        {mountAnalysisDetails({
                          analysis: item,
                          listExpanded: item.id === historyItemOpen,
                          isHistoryItem: true,
                        })}
                      </Styles.MobileHistoryItemDetails>
                    </Styles.MobileHistoryItem>
                  );
                })}
              </Styles.MobileHistoryContainer>
            )}

            <Styles.PaginationWrapper>
              <Styles.PaginationEmptyItem />

              <Pagination
                startIn={1}
                page={pageIndex}
                setPage={handleSetPage}
                pagesAmount={pagesAmount}
              />

              <Styles.PagesAmount>
                {itemsPerPageLabel}
                <Styles.SelectFieldContainer>
                  <SelectField
                    testId="selectItemsPerPage"
                    size="sm"
                    value={itemsPerPage}
                    options={itemsPerPageOptions}
                    setValue={label => handleSetItemsPerPage(Number(label))}
                  />
                </Styles.SelectFieldContainer>
              </Styles.PagesAmount>
            </Styles.PaginationWrapper>
          </Styles.HistoryWrapper>
        </Styles.Container>
      )}

    </Styles.Wrapper>
  );
};

FeatureSpeed.propTypes = {
  title: PropTypes.string,
  firstRow: PropTypes.string,
  secondRow: PropTypes.string,
  stillHave: PropTypes.node,
  dontHave: PropTypes.node,
  initTestLabel: PropTypes.string,
  loadingLastAnalysis: PropTypes.bool,
  leftAmount: PropTypes.number,
  requestSpeedAnalysis: PropTypes.func,
  getHistoryRequestStatus: PropTypes.string,
  resetRequestStatus: PropTypes.func,
  videoAbout: PropTypes.shape({
    title: PropTypes.string,
    src: PropTypes.string,
  }),
  getHistoryError: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default FeatureSpeed;
